import { render, staticRenderFns } from "./SendSmsLink.vue?vue&type=template&id=5ee5f006&scoped=true&"
import script from "./SendSmsLink.vue?vue&type=script&lang=js&"
export * from "./SendSmsLink.vue?vue&type=script&lang=js&"
import style0 from "./SendSmsLink.vue?vue&type=style&index=0&id=5ee5f006&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee5f006",
  null
  
)

export default component.exports